import { useEffect, useState } from 'react';
import '../styles/AuthForms.css';

function EmailVerification() {
  const [status, setStatus] = useState('verifying');
  const [message, setMessage] = useState('');

  useEffect(() => {
    verifyEmail();
  }, []);

  async function verifyEmail() {
    const params = new URLSearchParams(window.location.search);
    const token = params.get('token');

    if (!token) {
      setStatus('error');
      setMessage('Missing verification token');
      return;
    }

    try {
      const response = await fetch(
        `${import.meta.env.VITE_API_URL}/auth/verify-email?token=${token}`,
        { method: 'POST' }
      );

      const data = await response.json();

      if (data.success) {
        // Store JWT and redirect to Roblox linking (mandatory)
        localStorage.setItem('auth_token', data.token);
        setStatus('success');
        setMessage('Email verified! Now link your Roblox character...');
        setTimeout(() => {
          window.location.href = '/link-roblox';
        }, 2000);
      } else {
        setStatus('error');
        setMessage(data.error || 'Verification failed');
      }
    } catch (err) {
      setStatus('error');
      setMessage('Network error');
    }
  }

  return (
    <div className="verification-container">
      <div className="verification-card">
        {status === 'verifying' && (
          <>
            <div className="spinner"></div>
            <p>Verifying your email...</p>
          </>
        )}
        {status === 'success' && (
          <>
            <div className="success-icon">✅</div>
            <h2>Email Verified!</h2>
            <p>{message}</p>
          </>
        )}
        {status === 'error' && (
          <>
            <div className="error-icon">❌</div>
            <h2>Verification Failed</h2>
            <p>{message}</p>
            <button onClick={() => (window.location.href = '/')} className="btn-primary">
              Go Home
            </button>
          </>
        )}
      </div>
    </div>
  );
}

export default EmailVerification;
